import { AppModule } from 'app/module';
import Template from 'module/keyfactBox/template.hbs';
import './styles.scss';

export class KeyfactBox extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            employmentTypes: '.m-keyfactBox__jobEmploymentTypes',
            salaryRange: '.m-keyfactBox__jobSalaryRange',
            jobLevel: '.m-keyfactBox__jobLevel',
            jobLocations: '.m-keyfactBox__jobLocations',
            date: '.m-keyfactBox__jobDate',
            companyName: '.m-keyfactBox__companyName',
            employees: '.m-keyfactBox__companyEmployees',
            mainLocation: '.m-keyfactBox__mainLocation',
        };
    }

    getPropsFromDom() {
        return {
            job: {
                employmentTypes: this.dom.employmentTypes?.innerText,
                salaryRange: this.dom.salaryRange?.innerText,
                jobLevel: this.dom.jobLevel?.innerText,
                locations: this.dom.jobLocations?.innerText,
                date: this.dom.date?.innerText,
                isHomeOffice: this.dom.el.getAttribute('data-is-homeoffice') === 'true',
                isChiffre: this.dom.el.getAttribute('data-is-chiffre') === 'true',
                companyIsEmploymentAgency: this.dom.el.getAttribute('data-company-is-employment-agency') === 'true',
            },
            company: {
                name: this.dom.companyName?.innerText,
                employees: this.dom.employees?.getAttribute('data-employees'),
                mainLocation: this.dom.mainLocation?.innerText,
                isLinkable: this.dom.el.getAttribute('data-is-linkable') === 'true',
                slug: this.dom.el.getAttribute('data-company-slug'),
            },
        };
    }
}
